import React from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentFailed.css";
import WhiteButton from "../common_components/common_button/WhiteButton";

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <section className="payment-status">
      <div className="payment-status-card">

        <img
          src="/images/payment/failed.png"
          alt="failed"
          className="payment-status-icon"
        />

        <h2>Payment Failed</h2>

        <p>
          Unfortunately your payment could not be completed.
        </p>

        <WhiteButton
          title="Try Again"
          bg="#000"
          color="#f35f37"
          hoverBg="#000"
          hoverColor="#f35f37"
          onClick={() => navigate("/payment-method")}
        />

      </div>
    </section>
  );
};

export default PaymentFailed;